window.onload = function () {

    // Add animation bindings to elements
    lax.addElements('.parallax-item', {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [0, -150],
        ],
      },
    });
    lax.addElements('.parallax-item2', {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [0, -100],
        ],
      },
    });
    lax.addElements('.parallax-item3', {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [0, -130],
        ],
      },
    });
    lax.addElements('.parallax-item4', {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [0, -180],
        ],
      },
    });
    lax.addElements('.parallax-item5', {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [0, -110],
        ],
      },
    });
    lax.addElements('.parallax-item6', {
      scrollY: {
        translateY: [
          ["elInY", "elOutY"],
          [0, -110],
        ],
      },
    });
  }